import { Components } from '../lib/EdexClientJava';

export type NewInvestmentDto = Components.Schemas.NewInvestmentDto;
export type SimpleInvestmentDto = Components.Schemas.SimpleInvestmentDto;
export type Investment = Components.Schemas.InvestmentDto;
export type InvestmentFile = Components.Schemas.InvestmentFileDto;
export type InvestmentFileType = Components.Schemas.InvestmentFileType;
export type InvestmentStatus = Components.Schemas.InvestmentStatus;

export enum InvestorInvestmentStatusEnum {
  NEW = 'NEW',
  AGREEMENT_SENT = 'AGREEMENT_SENT',
  AGREEMENT_SIGNED = 'AGREEMENT_SIGNED',
  FUNDS_REQUEST = 'FUNDS_REQUEST',
  FUNDS_RECEIVED = 'FUNDS_RECEIVED',
  AOI_SOA_SENT = 'AOI_SOA_SENT',
  AOI_SOA_SIGNED = 'AOI_SOA_SIGNED',
  EGMS_DECISION_SENT = 'EGMS_DECISION_SENT',
  EGMS_DECISION_SIGNED = 'EGMS_DECISION_SIGNED',
  TOKENIZATION = 'TOKENIZATION',
  DONE = 'DONE',
}
